import axios from "axios";

// Setup Axios instance

const apiurl = process.env.REACT_APP_API_BASE_URL;


const api = axios.create({
  baseURL: apiurl, // Change this to your API endpoint
});

// Optional: Add request interceptors for handling token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
